<template>
  <div id="login">
    <section class="section">
      <div class="d-flex flex-wrap align-items-stretch">
        <div class="col-lg-4 col-md-6 col-12 order-lg-1 min-vh-100 order-2 bg-white">
          <div class="p-4 m-3">
            <a href="/">
              <img
                src="./../../assets/img/icon-jembrana-20.png"
                alt="logo"
                width="80"
                class="shadow-light mb-5 mt-2"
              >
            </a>
            <h4 class="text-dark font-weight-normal">
              <span class="font-weight-bold">Sipeduli Jembrana</span>
            </h4>
            <p class="text-muted">
              Buat permohonan Akta Kelahiran, KTP Elektronik dan dokumen lainnya dari rumah.
            </p>
            <form
              method="POST"
              action="POST"
              @submit="onSubmit"
            >
              <div class="form-group">
                <label for="username">Email/Username</label>
                <input
                  id="username"
                  type="text"
                  class="form-control"
                  name="username"
                  v-model="form.username"
                  tabindex="1"
                  required
                  autofocus
                >
                <div class="invalid-feedback">
                  Please fill in your email
                </div>
              </div>

              <div class="form-group">
                <div class="d-block">
                  <label
                    for="password"
                    class="control-label"
                  >Password</label>
                </div>
                <div class="input-group mb-3">
                  <input
                    id="password"
                    :type="(!isShowPassword) ? 'password' : 'text'"
                    class="form-control"
                    name="password"
                    tabindex="2"
                    required
                    v-model="form.password"
                  >
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="isShowPassword = !isShowPassword"
                    >
                      <i
                        class="fa"
                        :class="(!isShowPassword) ? 'fa-eye' : 'fa-eye-slash'"
                      />
                    </button>
                  </div>
                </div>
								
                <div class="invalid-feedback">
                  please fill in your password
                </div>
              </div>

              <div
                v-if="showCaptcha"
                class="form-group"
              >
                <img
                  id="captcha-img"
                  src=""
                >
                <button
                  type="button"
                  style="font-size: 10px;"
                  class="btn btn-link"
                  href="#"
                  @click="getCaptcha"
                >
                  <i class="fa fa-sync mr-2" />Ganti Captcha
                </button>
                <input
                  v-model="form.captcha"
                  id="captcha"
                  type="text"
                  class="form-control"
                  name="captcha"
                  tabindex="3"
                  required
                  placeholder="Masukkan teks diatas"
                >
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    name="remember"
                    v-model="simpanLogin"
                    class="custom-control-input"
                    id="remember-me"
                  >
                  <label
                    class="custom-control-label"
                    for="remember-me"
                  >Simpan data login saya</label>
                </div>
              </div>

              <div class="form-group text-right">
                <a
                  href="javascript:void(0)"
                  class="float-left mt-3"
                  @click="lupaAkun"
                >
                  Lupa username atau password?
                </a>
                <!-- <router-link to="/home" class="btn btn-primary btn-lg btn-icon icon-right" tabindex="4" tag="button">Login</router-link> -->
                <button
                  id="btnSubmit"
                  type="submit"
                  class="btn btn-primary btn-lg btn-icon icon-right"
                  tabindex="4"
                >
                  Login
                </button>
              </div>

              <div class="mt-5 text-center">
                Belum punya akun? <router-link to="/register">
                  Buat Akun
                </router-link>
              </div>
            </form>

            <div class="text-center mt-5 text-small" />
          </div>
        </div>
        <div
          class="col-lg-8 col-12 order-lg-2 order-1 min-vh-100 background-walk-y position-relative overlay-gradient-bottom" 
          :style="{ backgroundImage: 'url('+require('./../../assets/img/KR_Jagatnatha.jpg')+')' }"
        >
          <div class="absolute-bottom-left index-2">
            <div class="text-light p-5 pb-2">
              <div class="mb-5 pb-3">
                <h1 class="mb-2 display-4 font-weight-bold">
                  Kabupaten Jembrana
                </h1>
                <h5 class="font-weight-normal text-muted-transparent">
                  Bali, Indonesia
                </h5>
              </div>
              <!-- Photo by <a class="text-light bb" target="_blank" href="https://unsplash.com/photos/a8lTjWJJgLA">Justin Kauffman</a> on <a class="text-light bb" target="_blank" href="https://unsplash.com">Unsplash</a> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import swal from 'sweetalert'
import encrypt from './../../mixins/encrypt.js'

export default {
	name: 'Login',
	data(){
		return {
			showCaptcha: true, // setting untuk menampilkan captcha atau nggak
			form: {
				username: null,
				password: null,
				captcha: null
			},
			simpanLogin: false,
			isShowPassword: false,
			captchaStr: ''
		}
	},
	mixins: [encrypt],
	components: {
	},
	methods: {
		onSubmit(e){
			e.preventDefault()
			if(this.showCaptcha){
				if(this.form.captcha.toLocaleLowerCase() !== this.captchaStr.toLocaleLowerCase()){
					swal({
						title: "Gagal",
						text: "Captcha tidak sesuai",
						icon: "error",
						buttons: "Ok"
					})
					this.form.username = ''
					this.form.password = ''
					this.form.captcha = ''
					return false
				}
			}

			if(this.form.username.length < 8 || this.form.username.length > 100){
				swal({
					title: "Gagal",
					text: "Email/Username tidak valid",
					icon: "error",
					buttons: "Ok"
				})
				return false
			}
			
			let button = document.querySelector('#btnSubmit')
			let buttonHtml = button.innerHTML

			button.setAttribute('disabled', true)
			button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Login'

			// simpan ke localstorage jika simpan data login
			if(this.simpanLogin){
				this.$store.dispatch('simpanLogin', {username: this.form.username, password: this.encrypt(this.form.password)})
			} else {
				this.$store.dispatch('hapusLoginTersimpan')
			}

			let formData = new FormData()
			for ( let key in this.form ) {
					formData.append(key, this.form[key])
			}
			this.$store.dispatch('loginUser', formData).then(res => {
				// console.log(res)
				if(res.data.status){
					let authService = {
						isAuthenticated: true,
						currentRole: res.data.data.current_role,
						role: res.data.data.role,
						token: this.encrypt(res.data.data.token)
					}
					// console.log(authService)

					this.$store.dispatch('setAuthService', authService)
					
					// button.removeAttribute('disabled')
					// button.innerHTML = buttonHtml

					// swal({
					//	 title: "Berhasil",
					//	 text: res.data.message,
					//	 icon: "success",
					//	 buttons: "Ok"
					// }).then(val => {
						window.location.href = "/home"
					// })
					sessionStorage.setItem('auth', true)
				} else {
					button.removeAttribute('disabled')
					button.innerHTML = buttonHtml

					swal({
						title: "Gagal",
						text: res.data.message,
						icon: "error",
						buttons: "Ok"
					})
				}
			}).catch(err => {
				button.removeAttribute('disabled')
				button.innerHTML = buttonHtml

				if(err.response.status != 500){
					swal({
						title: "Gagal",
						text: err.response.data.message,
						text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
						icon: "error",
						buttons: "Ok"
					})
				} else {
					this.$router.push({path: '/500'})
				}
			})
		},
		lupaAkun(){
			swal({
				title: "Informasi",
				text: "Jika Anda lupa username atau password, silahkan datang ke Kantor Desa.",
				icon: "warning",
				buttons: "Ok"
			})
		},
		getCaptcha(){
			this.$store.dispatch('fetchCaptcha', Math.random()).then(res => {
				this.captchaStr = res.data.data.str
				document.querySelector('#captcha-img').setAttribute('src', res.data.data.img)
			})
		}
	},
	mounted() {
		if(this.showCaptcha){
			this.getCaptcha()
		}
	},
	created(){
		let akunTersimpan = this.$store.getters.getDataLoginTersimpan
		this.form.username = akunTersimpan.username
		this.form.password = this.decrypt(akunTersimpan.password)

		if(akunTersimpan.username != ''){
			this.simpanLogin = true
		}
	}
}
</script>

<style>
  .min-vh-100 {
    min-height: 100vh;
  }
</style>
